import cx from "classnames"
import type { PropsWithChildren } from "react"

export type MarketingNoteProps = PropsWithChildren<{
  variant: "success" | "tertiary"
  title?: string
  icon?: React.JSX.Element
  className?: string
}>

export const MarketingNote = ({
  children,
  title,
  icon,
  className,
  variant,
}: MarketingNoteProps) => (
  <div
    className={cx(
      `cobalt-marketing-note cobalt-marketing-note--${variant}`,
      className,
    )}
  >
    {icon && (
      <div className="cobalt-marketing-note__icon-container">{icon}</div>
    )}

    <div className="c-flex-1">
      {title && <div className="c-font-bold">{title}</div>}
      {children}
    </div>
  </div>
)
